export const watchedMutations = {
    updateCase: {
        myOrganisationArchivedCases: ({ mutation, query }) => {
            //We need a better solution than this shit
            const mutatedCase = mutation.result.data.updateCase;
            const cachedCases = query.result.myOrganisationArchivedCases;
            const searchString = query.variables.contains;
            const isCaseIncluded = cachedCases.some(
                Case => Case.id === mutatedCase.id
            );
            const shouldCaseBeIncluded =
                mutatedCase.archived &&
                mutatedCase.name.indexOf(searchString) !== -1;

            const updatedResult = query.result;
            if (isCaseIncluded && !shouldCaseBeIncluded) {
                // if the mutatedCase is found in the cached list and it should not be there after the mutation, remove it
                updatedResult.myOrganisationArchivedCases = cachedCases.filter(
                    Case => Case.id !== mutatedCase.id
                );
                return updatedResult;
            } else if (!isCaseIncluded && shouldCaseBeIncluded) {
                // if the mutatedCase is not found in the cached list and it should be there after the mutation, add it
                updatedResult.myOrganisationArchivedCases = [
                    mutatedCase,
                    ...cachedCases
                ];
                return updatedResult;
            }
            // else an in-place update is already sufficient so no update is necessary
        }
    },
    deleteCase: {
        myOrganisationArchivedCases: ({ mutation, query }) => {
            //We need a better solution than this shit
            const mutatedCase = mutation.result.data.deleteCase;
            const cachedCases = query.result.myOrganisationArchivedCases;
            const updatedResult = query.result;

            if (mutatedCase.archived) {
                updatedResult.myOrganisationArchivedCases = cachedCases.filter(
                    Case => Case.id !== mutatedCase.id
                );

                return updatedResult;
            }
        }
    }
};
